import {ActionActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const ActionRequestInit = () => {
    return {
        type:ActionActionType.Action_INIT
    }
}

export const ActionSuccess = (
    objeckt: any
) => {
    return {
        type: ActionActionType.Action_INIT,
        objeckt: objeckt
    }
}

export const getAction = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            ActionSuccess(
                objeckt
            )
        )
    }
}
